/**
 * Handle error response.
 * @param { Object.<string, any> } error
 * @param { string } defaultError
 *
 * @returns { void }
 */
export function handleAxiosError(error, default_error = null, force_toastr_type = 'error') {
  if (error?.response?.status === 401) {
    if (error.response.data.error.message) {
      toastr[force_toastr_type](error.response.data.error.message);
    } else {
      toastr[force_toastr_type]('You are not authorised to perform this task');
    }
  } else {
    const error_response = error.response;
    let response_data = false;
    let response_error = false;
    let response_errors = false;
    let response_successes = false;

    // Determine the type of error we have
    if (error_response?.data) {
      // Standard error from error response such as respondBadRequestError
      if (error_response.data.error) {
        response_error = error_response.data.error.message;
      }
      response_data = error_response.data;

      if (response_data.message) {
        response_error = response_data.message;
      } else if (response_data.data) {
        // It is a standard error response
        if (response_data.error) {
          response_error = response_data.error;
        }
        // Is it partial error get the errors
        if (response_data.data.errors) {
          response_errors = response_data.data.errors;
        }
        // is it a partial error get the successes
        if (response_data.data.success) {
          response_successes = response_data.data.success;
        }
      }
    }

    // Failed with successes (from respondSuccessWithErrors)
    if (response_successes && response_errors) {
      if (response_errors.isArray(response_errors)) {
        response_errors.forEach((error_message) => {
          toastr[force_toastr_type](error_message);
        });
      } else {
        toastr[force_toastr_type](response_errors);
      }

      if (response_successes.isArray(response_successes)) {
        response_successes.forEach((success_message) => {
          toastr[force_toastr_type](success_message);
        });
      }
    } else if (response_error) {
      toastr[force_toastr_type](response_error);
    } else if (error.code !== `ECONNABORTED`) {
      // Throw a default error
      if (default_error) {
        console.error(error);
        toastr[force_toastr_type](default_error);
      } else {
        console.error(error);
        toastr[force_toastr_type]('An error occurred');
      }
    }
  }
}
